export const primaryRed = "#ff0000";

export const tableButtonGreenBg = "#B0D9A9";
export const tableButtonGreenText = "#006839";

export const tableButtonRedBg = "#F37D90";
export const tableButtonRedText = "#A91F22";
